// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"15dc95b3","98":"f5e79284","219":"db027182","448":"47f47d8b","580":"2e564059","584":"0850381c","846":"f6018060"}[chunkId] + ".chunk.js";
};